module.exports = __webpack_public_path__ + "detailed-cbf22510dee25bac18924d11526d552b.png";